import {Injectable} from '@angular/core';
import {OAuthService} from 'angular-oauth2-oidc';
import {FilterObject} from '../../shared/models/FilterBarObject';
import {
  NetworkConfigurationMetaData,
  NetworkConfigurationResult,
  NetworkDetailsResult,
  NetworkQueryResult,
  NetworkResultData
} from '../models/network/network-query-result';
import {NetworksFilter} from '../store/networks/networks.model';
import {GraphQLClientService} from './graphql-client.service';

@Injectable({
  providedIn: 'root'
})
export class NetworksService {

  constructor(private oauthService: OAuthService, private graphQLClient: GraphQLClientService) {
  }

  public async getNetworks(page: number = 0, count: number = 0, filter: FilterObject<NetworksFilter>): Promise<NetworkResultData> {
    const query = `query{
       networks(nameContains: "${filter?.search ? filter?.search : ''}" ${filter?.filter?.status !== null ? `controllersStatusId: ${filter.filter.status}` : ''})
       {results{id description name typeId typeName controllersStatusMessage controllersStatusId controllersStatus controllersCount address} totalCount
       }
      }`;

    return this.graphQLClient.requestAsync<NetworkQueryResult>(query).then((response) => {
      return response?.data?.networks;
    }).catch(() => {
      return null;
    });
  }

  public async getConfiguration(): Promise<NetworkConfigurationMetaData> {
    const query = `{
    configurations{
      networkConfigurations {networkStatus {id description}  panelStatus {id description} networkTypes{id description}}
      }
    }
  `;
    return (await this.graphQLClient.requestAsync<NetworkConfigurationResult>(query))?.data.configurations.networkConfigurations;
  }

  getNetworkDetailsById(networkId: number): Promise<NetworkDetailsResult> {
    const query = `query{
      network(id:${networkId})
      {
        id name address networkStatus networkStatusId controllers {id name isTestable statusDate statusDescription statusId typeDescription version} events {eventTypeId}
      }
    }`;

    return this.graphQLClient.requestAsync<NetworkDetailsResult>(query).then(({data}) => {
      return data;
    }).catch(() => {
      return null;
    });
  }

  async testController(panelId: any): Promise<any> {
      const query = `mutation{
        testPanel(
          testPanelCommand: ${JSON.stringify({...panelId}).replace(/"(\w{2,})":/gm,'$1:')}
          )
      }`;
    this.graphQLClient.setHeader('token', this.oauthService.getAccessToken());
    return this.graphQLClient.request<any>(query).then(data => {
      return data;
    }).catch(() => {
      return null;
    });
  }
}
